export type PopoverAlign = "start" | "end";

export const POPOVER_ALIGN_CLASSES: Record<PopoverAlign, string> = {
  start: "right-auto",
  end: "left-auto",
};
